// react
import { useEffect, useState } from "react";
// react query
import { GetPlans } from "../../../services/client/plans/getPlans.tsx";
import { DeletePlans } from "../../../services/admin/plans/deletePlans.tsx";
// custom hook
import useGetData from "../../../hook/getData.tsx";
import useDeleteData from "../../../hook/deleteData.tsx";

export const GetPlansController = () => {
    const { data, isLoading, refetch } = useGetData(['plans'], GetPlans)
    useEffect(() => {
        refetch()
    }, [refetch])
    const [title, setTitle] = useState<string>('');
    const [id, setid] = useState<string | number>('');
    let changeData = (id: number | string, title: string) => {
        setid(id)
        setTitle(title)
    }
    let delteData: any;
    const { deleteItem } = useDeleteData(delteData, DeletePlans, refetch)
    const onSubmit = (id: number | string) => {
        deleteItem(id)
    }
    return { data, isLoading, title, id, changeData, onSubmit }
}